<template>
  <div id="app" class="app-wrapper app-root">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <add-account-modal
      :show="showAddAccountModal"
      :has-accounts="hasAccounts"
    />
    <woot-snackbar-box />
    <network-notification />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddAccountModal from '../dashboard/components/layout/sidebarComponents/AddAccountModal';
import WootSnackbarBox from './components/SnackbarContainer';
import NetworkNotification from './components/NetworkNotification';
import { accountIdFromPathname } from './helper/URLHelper';
import alertMixin from 'shared/mixins/alertMixin';
import twilioCallMixin from 'shared/mixins/twilioCallMixin.js';

export default {
  name: 'App',
  mixins: [alertMixin, twilioCallMixin],
  components: {
    WootSnackbarBox,
    AddAccountModal,
    NetworkNotification,
  },

  data() {
    return {
      showAddAccountModal: false,
    };
  },

  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentUser: 'getCurrentUser',
    }),
    hasAccounts() {
      return (
        this.currentUser &&
        this.currentUser.accounts &&
        this.currentUser.accounts.length !== 0
      );
    },
  },

  watch: {
    currentUser() {
      if (!this.hasAccounts) {
        this.showAddAccountModal = true;
      }
    },
  },
  mounted() {
    this.$store.dispatch('setUser');
    this.setLocale(window.peasyConfig.selectedLocale);
    this.initializeAccount();
    this.listenGlobalEvents();
  },

  methods: {
    setLocale(locale) {
      this.$root.$i18n.locale = locale;
    },

    async initializeAccount() {
      const { pathname } = window.location;
      const accountId = accountIdFromPathname(pathname);

      if (accountId) {
        await this.$store.dispatch('accounts/get');
        await this.$store.dispatch('accounts/fetchBasePath');
        const { locale } = this.getAccount(accountId);
        await this.$store.dispatch('accounts/fetchContactStatus');
        await this.$store.dispatch('accounts/fetchCommunalInboxes');
        await this.$store.dispatch('accounts/fetchSubscriptionPlans', {
          type: 'all',
        });

        if (this.$store.getters['accounts/getUserPlan']?.length === 0) {
          await this.$store.dispatch('accounts/fetchAccountInboxes');
        }

        this.setLocale(locale);
        // initialize twilio call SDK
        // this.initializeTwilio();
        this._registerTwilioBusListeners();
      }
    },
    listenGlobalEvents() {
      bus.$on('actionCableEvent_OrderMissed', data => {
        const now = new Date();
        const date = now.toLocaleDateString('en-US');
        const time = now.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        });
        this.showAlert(
          `You've just missed out on a RM ${data.grand_total} sales order at ${date} ${time}. Top-up now.`
        );
      });
    },
    // end methods
  },
};
</script>

<style lang="scss">
@import './assets/scss/app';
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
